// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
import theme from '../../../styled-components/dark';
import palette from '../../../styled-components/palette';
import { BoomSkinIds } from '../types/global';
import { BoomStepStatuses } from '../types/steps';

export const BoomSkinIdWithoutIdleAnimation = [BoomSkinIds.HALLOWEEN];

const BoomUIBySkinId = {
  [BoomSkinIds.HALLOWEEN]: {
    WRAPPER_STYLE: {
      backgroundColor: '#020005',
      extendedShadowBackgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.8) 100%)',
      extendedShadowHeight: '100%',
      shadowBackgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 8, 0) 0%, #100025 38%, #100025 100%)',
      shadowHeight: '30%',
    },
    TEXT_STYLE: {
      color: palette.white,
      separatorColor: 'rgba(255, 255, 255, 0.8)',
      subtitleColor: palette.bluegrey200,
      lockedColor: '#bb33ff',
      pendingColor: '#ff7733',
      pendingBgColor: 'rgba(217, 98, 38, 0.15)',
      wonColor: palette.greenwinamax350,
      wonBgColor: 'rgba(38, 217, 128, 0.15)',
    },
    ENROLLMENT_WINDOW_STYLE: {
      messageTextColor: palette.bluegrey200,
    },
    BETSLIP_BAND_STYLE: new Proxy(
      {
        dark: {
          color: palette.white,
          backgroundColor: palette.black,
        },
        light: {
          color: palette.white,
          backgroundColor: palette.bluegrey900,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.light;
          }
          return origin[key];
        },
      },
    ),
    BUTTON_STYLE: new Proxy(
      {
        primary: {
          color: palette.white,
          backgroundColor: palette.redwinamax500,
          backgroundShadowColor: palette.redwinamax700,
          textShadowColor: palette.redwinamax850,
        },
        secondary: {
          color: palette.white,
          backgroundColor: '#ff5500',
          backgroundShadowColor: '#cc2200',
          textShadowColor: palette.bluewinamax850,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.primary;
          }
          return origin[key];
        },
      },
    ),
    BOX_STYLE: new Proxy(
      {
        success: {
          borderWidth: 1,
          borderColor: '#3df59920',
          borderGradient: 'linear-gradient(17deg, rgba(61, 245, 153, 0) 6%, rgba(144,255,200, .4) 89%)',
          borderGradientSmall: 'linear-gradient(23deg, rgba(76, 243, 159, 0) 50%, rgba(168,255,211, .4) 89%)',
          backgroundGradient:
            'radial-gradient(circle at 50% 56%, rgba(61, 245, 153, 0), #71ffb814 94%), linear-gradient(17deg, rgba(61, 245, 153, 0) 6%, #90ffc814 89%)',
        },
        default: {
          borderWidth: 1,
          borderColor: '#da90ff20',
          borderGradient: 'linear-gradient(16deg, rgba(184, 61, 245, 0) 3%, rgba(218,144,255, .4) 89%)',
          borderGradientSmall: 'linear-gradient(23deg, rgba(187, 76, 243, 0) 50%, rgba(226,168,255, .4) 89%)',
          backgroundGradient:
            'radial-gradient(circle at 50% 56%, rgba(184, 61, 245, 0), #d071ff10 94%), linear-gradient(16deg, rgba(184, 61, 245, 0) 3%, #da90ff10 89%)',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    SEPARATOR_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: '#CF5417',
          fillOpacity: 1,
          strokeOpacity: 0.8,
          strokeGradientPrimaryColor: '#FF7733',
          strokeGradientSecondaryColor: '#FFCDB5',
        },
        default: {
          fillColor: '#7300AC',
          fillOpacity: 0.75,
          strokeOpacity: 0.6,
          strokeGradientPrimaryColor: '#B83DF5',
          strokeGradientSecondaryColor: '#F7E8FF',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    STEP_CIRCLE_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: '#F57A3D',
          fillOpacity: 0.2,
          strokeColor: '#D96226',
        },
        default: {
          fillColor: '#B83DF5',
          fillOpacity: 0.1,
          strokeColor: '#9D26D9',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    TitleColorByStepStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: '#ff7733',
        [BoomStepStatuses.LOCKED]: '#bb33ff',
        [BoomStepStatuses.PENDING]: '#ff7733',
        [BoomStepStatuses.WON]: palette.greenwinamax350,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return 'white';
          }
          return origin[key];
        },
      },
    ),
    ButtonStyleByStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: {
          borderColor: '#e56e1e',
          color: '#e56e1e',
        },
        [BoomStepStatuses.LOCKED]: {
          borderColor: 'transparent',
          color: 'white',
        },
        [BoomStepStatuses.PENDING]: {
          borderColor: '#e56e1e',
          color: '#e56e1e',
        },
        [BoomStepStatuses.WON]: {
          borderColor: '#70dba6',
          color: '#9FFFCB',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin[BoomStepStatuses.OPEN];
          }
          return origin[key];
        },
      },
    ),
    TabBarItem: {
      active: {
        color: '#ff7733',
      },
      passive: {
        color: theme.TabBar.Button.default.passive.color,
      },
    },
  },
  [BoomSkinIds.VALENTINE]: {
    WRAPPER_STYLE: {
      backgroundColor: 'transparent',
      extendedShadowBackgroundImage: 'none',
      extendedShadowHeight: '0%',
      shadowBackgroundImage: 'none',
      shadowHeight: '0%',
    },
    TEXT_STYLE: {
      color: palette.white,
      separatorColor: 'rgba(255, 255, 255, 0.8)',
      subtitleColor: palette.bluegrey200,
      lockedColor: '#ff668c',
      pendingColor: '#ff668c',
      pendingBgColor: 'rgba(217, 98, 38, 0.15)',
      wonColor: palette.greenwinamax350,
      wonBgColor: 'rgba(38, 217, 128, 0.15)',
    },
    ENROLLMENT_WINDOW_STYLE: {
      messageTextColor: palette.bluegrey200,
    },
    BETSLIP_BAND_STYLE: new Proxy(
      {
        dark: {
          color: palette.white,
          backgroundColor: palette.black,
        },
        light: {
          color: palette.white,
          backgroundColor: palette.bluegrey900,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.light;
          }
          return origin[key];
        },
      },
    ),
    BUTTON_STYLE: new Proxy(
      {
        primary: {
          color: palette.white,
          backgroundColor: palette.redwinamax500,
          backgroundShadowColor: palette.redwinamax700,
          textShadowColor: palette.redwinamax850,
        },
        secondary: {
          color: palette.white,
          backgroundColor: '#f20d46',
          backgroundShadowColor: '#91082a',
          textShadowColor: palette.bluewinamax850,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.primary;
          }
          return origin[key];
        },
      },
    ),
    BOX_STYLE: new Proxy(
      {
        success: {
          borderWidth: 1,
          borderColor: '#3df59920',
          borderGradient: 'linear-gradient(16deg, rgba(184, 61, 245, 0) 3%, rgba(61, 245, 153, 1) 89%)',
          borderGradientSmall: 'linear-gradient(23deg, rgba(187, 76, 243, 0) 50%, rgb(209, 236, 250, 1) 89%)',
          backgroundGradient: 'radial-gradient(circle at 47% 50%, rgba(23, 94, 130, 0.7), rgba(8, 31, 43, 0.7) 86%)',
        },
        default: {
          borderWidth: 1,
          borderColor: '#d1ecfa20',
          borderGradient: 'linear-gradient(16deg, rgba(184, 61, 245, 0) 3%, rgba(209, 236, 250, 1) 89%)',
          borderGradientSmall: 'linear-gradient(23deg, rgba(187, 76, 243, 0) 50%, rgb(209, 236, 250, 1) 89%)',
          backgroundGradient: 'radial-gradient(circle at 47% 50%, rgba(23, 94, 130, 0.7), rgba(8, 31, 43, 0.7) 86%)',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    SEPARATOR_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: 'rgba(255, 102, 140, 0.75)',
          fillOpacity: 1,
          strokeOpacity: 0.8,
          strokeGradientPrimaryColor: '#FF7733',
          strokeGradientSecondaryColor: '#FFCDB5',
        },
        default: {
          fillColor: 'rgba(0, 115, 172, 0.75)',
          fillOpacity: 0.75,
          strokeOpacity: 0.6,
          strokeGradientPrimaryColor: '#B83DF5',
          strokeGradientSecondaryColor: '#F7E8FF',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    STEP_CIRCLE_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: '#000',
          fillOpacity: 0.5,
          fillStopOpacity: 1,
          strokeColor: '#c20a38',
        },
        default: {
          fillColor: '#0f3f57',
          fillOpacity: 0.5,
          fillStopOpacity: 1,
          strokeColor: '#269dd9',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    TitleColorByStepStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: '#fff',
        [BoomStepStatuses.LOCKED]: '#fff',
        [BoomStepStatuses.PENDING]: '#fff',
        [BoomStepStatuses.WON]: palette.greenwinamax350,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return 'white';
          }
          return origin[key];
        },
      },
    ),
    ButtonStyleByStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: {
          borderColor: '#ff668c',
          color: '#ff668c',
          backgroundColor: '#000',
        },
        [BoomStepStatuses.LOCKED]: {
          borderColor: 'transparent',
          color: 'white',
        },
        [BoomStepStatuses.PENDING]: {
          borderColor: '#ff668c',
          color: '#ff668c',
          backgroundColor: '#000',
        },
        [BoomStepStatuses.WON]: {
          borderColor: '#70dba6',
          color: '#9FFFCB',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin[BoomStepStatuses.OPEN];
          }
          return origin[key];
        },
      },
    ),
    TabBarItem: {
      active: {
        color: '#f20d46',
      },
      passive: {
        color: theme.TabBar.Button.default.passive.color,
      },
    },
  },
  [BoomSkinIds.PATRICK]: {
    ITEM_WRAPPER: {
      marginTop: 2, // em
    },
    WRAPPER_STYLE: {
      backgroundColor: 'transparent',
      extendedShadowBackgroundImage: 'none',
      extendedShadowHeight: '0%',
      shadowBackgroundImage: 'none',
      shadowHeight: '0%',
    },
    TEXT_STYLE: {
      color: palette.white,
      separatorColor: 'rgba(255, 255, 255, 0.8)',
      subtitleColor: palette.bluegrey200,
      lockedColor: '#62d926',
      pendingColor: '#ffaa00',
      pendingBgColor: 'rgba(217, 98, 38, 0.15)',
      wonColor: palette.greenwinamax350,
      wonBgColor: 'rgba(38, 217, 128, 0.15)',
    },
    ENROLLMENT_WINDOW_STYLE: {
      messageTextColor: palette.bluegrey200,
    },
    BETSLIP_BAND_STYLE: new Proxy(
      {
        dark: {
          color: palette.white,
          backgroundColor: palette.black,
        },
        light: {
          color: palette.white,
          backgroundColor: palette.bluegrey900,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.light;
          }
          return origin[key];
        },
      },
    ),
    BUTTON_STYLE: new Proxy(
      {
        primary: {
          color: palette.white,
          backgroundColor: palette.redwinamax500,
          backgroundShadowColor: palette.redwinamax700,
          textShadowColor: palette.redwinamax850,
        },
        secondary: {
          color: palette.white,
          backgroundColor: '#f20d46',
          backgroundShadowColor: '#91082a',
          textShadowColor: palette.bluewinamax850,
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.primary;
          }
          return origin[key];
        },
      },
    ),
    BOX_STYLE: new Proxy(
      {
        success: {
          borderWidth: 1,
          borderColor: '#3df59920',
          borderGradient: 'linear-gradient(16deg, rgba(184, 61, 245, 0) 3%, rgba(61, 245, 153, 1) 89%)',
          borderGradientSmall: 'linear-gradient(23deg, rgba(187, 76, 243, 0) 50%, rgb(209, 236, 250, 1) 89%)',
          backgroundGradient: 'radial-gradient(circle at 47% 50%, rgba(23, 94, 130, 0.7), rgba(8, 31, 43, 0.7) 86%)',
        },
        default: {
          borderWidth: 1,
          borderColor: '#d1ecfa20',
          borderGradient: 'linear-gradient(6deg, rgba(255, 255, 255, 0) 28%, #d1fae5 89%)',
          borderGradientSmall: 'linear-gradient(8deg, rgba(255, 255, 255, 0) 28%, #d1fae5 89%)',
          backgroundGradient: 'radial-gradient(circle at 47% 50%, rgba(23, 130, 77, 0.7), rgba(8, 43, 26, 0.7) 86%)',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    SEPARATOR_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: 'rgba(255, 212, 0, 0.75)',
          fillOpacity: 1,
          strokeOpacity: 0.8,
          strokeGradientPrimaryColor: 'rgba(254, 231, 237, 0.99)',
          strokeGradientSecondaryColor: '#fffbe8',
        },
        default: {
          fillColor: '#26d980',
          fillOpacity: 0.75,
          strokeOpacity: 0.6,
          strokeGradientPrimaryColor: '#B83DF5',
          strokeGradientSecondaryColor: '#F7E8FF',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    STEP_CIRCLE_STYLE: new Proxy(
      {
        inProgress: {
          fillColor: 'rgba(153, 127, 0, 0.8)',
          fillOpacity: 0.5,
          fillStopOpacity: 1,
          strokeColor: '#ffaa00',
        },
        default: {
          fillColor: '#0f5733',
          fillOpacity: 0.5,
          fillStopOpacity: 1,
          strokeColor: '#26d980',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin.default;
          }
          return origin[key];
        },
      },
    ),
    TitleColorByStepStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: '#62d926',
        [BoomStepStatuses.LOCKED]: '#62d926',
        [BoomStepStatuses.PENDING]: '#62d926',
        [BoomStepStatuses.WON]: palette.greenwinamax350,
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return 'white';
          }
          return origin[key];
        },
      },
    ),
    ButtonStyleByStatus: new Proxy(
      {
        [BoomStepStatuses.OPEN]: {
          borderColor: '#ffaa00',
          color: '#ffaa00',
          backgroundColor: '#000',
        },
        [BoomStepStatuses.LOCKED]: {
          borderColor: 'transparent',
          color: 'white',
        },
        [BoomStepStatuses.PENDING]: {
          borderColor: '#ffaa00',
          color: '#ffaa00',
          backgroundColor: '#000',
        },
        [BoomStepStatuses.WON]: {
          borderColor: '#70dba6',
          color: '#9FFFCB',
        },
      },
      {
        get(origin, key) {
          if (!origin[key]) {
            return origin[BoomStepStatuses.OPEN];
          }
          return origin[key];
        },
      },
    ),
    TabBarItem: {
      active: {
        color: '#62d926',
      },
      passive: {
        color: theme.TabBar.Button.default.passive.color,
      },
    },
  },
};

export default BoomUIBySkinId;
